import React from "react";
import racingIcon from "../assets/svg/racing.svg";
import "../styles/divider.css";

const Divider = () => {
  return (
    <div className="about-divider">
      <img src={racingIcon} alt="divider icon" className="divider-svg" />
      <img src={racingIcon} alt="divider icon" className="divider-svg" />
      <img src={racingIcon} alt="divider icon" className="divider-svg" />
      <img src={racingIcon} alt="divider icon" className="divider-svg" />
    </div>
  );
};

export default Divider;
